import { render, staticRenderFns } from "./QuestionnaireTtemplate.vue?vue&type=template&id=0cfaa209&scoped=true"
import script from "./QuestionnaireTtemplate.vue?vue&type=script&lang=js"
export * from "./QuestionnaireTtemplate.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireTtemplate.vue?vue&type=style&index=0&id=0cfaa209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfaa209",
  null
  
)

export default component.exports